import http from '@/util/http';

/**
 * 获取职位列表 https://zptopic.58.com/beerandskittles/info/list?page=1&pageSize=50&pageType=zpchihewanle&pid=1&dispcateid=1&type=getHeadImage,getSlideImage,getTradeTab,getInfoList
 * @param {number} page 请求数据页码
 * @param {number} pageSize 一页多少条数据
 * @param {string} pageType 	页面类型 默认：zpchihewanle
 * @param {string} pid pid
 * @param {string} dispcateid 类别ID
 * @param {number} type getHeadImage 获取静态头图 getSlideImage 获取轮播图 getTradeTab 获取行业Tab getInfoList 获取帖子列表
 */

export function getJobList({
	page,
	pageSize,
	pageType,
	pid,
	dispcateid,
	type
}) {
	return http.get(
		'/beerandskittles/info/list',
		{
			page,
			pageSize,
			pageType,
			pid,
			dispcateid,
			type
		},
		'6201dc81aa398e03a373ba0c'
	);
}
